

// default color for the charts
let chartColor = "#FFFFFF";

// Brand-specific color mapping for consistent colors across all category charts
const brandColorPalette = [
  "#437f57", // success-color (green) - moved to first position
  "#7b93AD", // info-color (blue)
  "#d96d6d", // danger-color (red)
  "#ffe28c", // card-background-yellow (bright yellow)
  "#ff8f5e", // card-background-orange (orange)
  "#b8d8d8", // card-background-blue (light blue)
  "#d5e5a3", // card-background-green (light green)
  "#baa9ba", // card-background-purple (purple)
  "#dcb285", // brown-color (tan)
  "#d6c1ab", // card-background-brown (beige)
  "#BCA9A9", // warning-color (muted pink)
  "#737894", // purple-color (slate)
  "#60773d", // card-font-green (dark green)
  "#b25825", // card-font-yellow (dark orange)
  "#506568", // card-font-blue (dark blue-gray)
  "#75442e", // card-font-brown (dark brown)
  "#3a283d", // card-font-purple (dark purple)
  "#772510", // card-font-orange (very dark orange)
  "#252422", // card-black-color (black) - moved to end
  "#1d1b1c"  // primary-color (dark) - moved to end as fallback
];

// Function to get consistent color for a brand across all charts
const getBrandColor = (brandName, allBrandNames = []) => {
  if (!brandName) return brandColorPalette[0];

  // Sort brand names to ensure consistent ordering
  const sortedBrands = [...allBrandNames].sort();
  const brandIndex = sortedBrands.indexOf(brandName);

  if (brandIndex === -1) {
    // Fallback: use simple hash if brand not in list
    let hash = 0;
    for (let i = 0; i < brandName.length; i++) {
      hash = brandName.charCodeAt(i) + ((hash << 5) - hash);
    }
    return brandColorPalette[Math.abs(hash) % brandColorPalette.length];
  }

  return brandColorPalette[brandIndex % brandColorPalette.length];
};
// ##############################
// // // Function that converts a hex color number to a RGB color number
// #############################
const hexToRGB = (hex, alpha) => {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
};

// ##############################
// // // Chart variables
// #############################

// #########################################
// // // used inside src/views/Dashboard.js and src/views/Charts.js
// #########################################
const chartExample1 = {
  data: {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
    ],
    datasets: [
      {
        label: "$",
        borderColor: "#6bd098",
        pointRadius: 0,
        pointHoverRadius: 0,
        fill: true,
        borderWidth: 3,
        barPercentage: 1.6,
        tension: 0.4,
        data: [542, 480, 430, 550, 530, 453, 380, 434, 568, 610],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },

    scales: {
      y: {
        ticks: {
          color: "#1d1b1c",
          beginAtZero: false,
          maxTicksLimit: 5,
          //padding: 20
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          padding: 20,
          color: "#1d1b1c",
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample2 = {
  data: (canvas) => {
    let ctx = canvas.getContext("2d");

    let gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, "#BCA9A9");
    gradientStroke.addColorStop(1, chartColor);

    let gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
    gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
    gradientFill.addColorStop(1, hexToRGB("#BCA9A9", 0.4));
    return {
      labels: ["12pm", "3pm", "6pm", "9pm", "12am", "3am", "6am", "9am"],
      datasets: [
        {
          label: "Email Stats",
          borderColor: "#BCA9A9",
          pointHoverRadius: 0,
          pointRadius: 0,
          fill: true,
          backgroundColor: '#BCA9A9',
          borderWidth: 3,
          barPercentage: 1.6,
          tension: 0.4,
          data: [40, 500, 650, 700, 1200, 1250, 1300, 1900],
        },
      ],
    };
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },
    scales: {
      y: {
        type: 'linear',
        min: 0,
        ticks: {
          color: "#1d1b1c",
          stepSize: 100000,
          precision: 0,
        },
        afterBuildTicks: function(scale) {
          const max = Math.max(...scale.chart.data.datasets[0].data);
          const ticks = [];
          for (let i = 0; i <= max + 100000; i += 100000) {
            ticks.push({ value: i });
          }
          scale.ticks = ticks;
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          padding: 20,
          color: "#1d1b1c",
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample3 = {
  data: (canvas) => {
    let ctx = canvas.getContext("2d");

    let gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
    gradientStroke.addColorStop(0, "#7b93AD");
    gradientStroke.addColorStop(1, chartColor);

    let gradientFill = ctx.createLinearGradient(0, 170, 0, 50);
    gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
    gradientFill.addColorStop(1, hexToRGB("#7b93AD", 0.4));
    return {
      labels: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
      ],
      datasets: [
        {
          
          label: "Active Countries",
          backgroundColor: "#7b93AD",
          borderColor: "#7b93AD",
          pointHoverRadius: 0,
          pointRadius: 0,
          fill: true,
          borderWidth: 3,
          barPercentage: 1.6,
          tension: 0.4,
          data: [80, 78, 86, 96, 83, 85, 76, 75, 88, 90],
        },
      ],
    };
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },
    scales: {
      y: {
        ticks: {
          color: "#1d1b1c",
          beginAtZero: false,
          maxTicksLimit: 5,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          padding: 20,
          color: "#1d1b1c",
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample4 = {
  data: {
    labels: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],
    datasets: [
      {
        // label: "Cases Sold",
        backgroundColor: "#7b93AD",
        borderColor: "#7b93AD",
        borderWidth: 1,
        barPercentage: 0.5,
        data: [
          9200, 8700, 9500, 9900, 8600, 9100,
          8800, 9400, 9700, 9300, 8500, 9600
        ],
      }
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      // tooltip: {
      //   enabled: true,
      //   backgroundColor: "rgba(0,0,0,0.7)",
      //   titleFont: { size: 14, weight: "bold" },
      //   bodyFont: { size: 14 },
      //   padding: 10,
      // },
    },
    scales: {
      y: {
        beginAtZero: true,
        min: 0,
        max: 15000,
        ticks: {
          stepSize: 500,
          color: "#9f9f9f",
        },
        grid: {
          drawBorder: false,
          color: "#e5e5e5",
        },
      },
      x: {
        ticks: {
          color: "#9f9f9f",
        },
        grid: {
          display: false,
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
// variables/charts.js

// ─── Sales by Category pies ──────────────────────────────────────────────────

// Wine (8 brands)
const chartWine = {
  data: {
    labels: [
      "te Pa Reserves",
      "te Pa",
      "Montford Estate",
      "Pa Road",
      "Mount Michael",
      "The Mountaineer",
      "Silhouette",
      "Church Bay Estate"
    ],
    datasets: [{
      data: [20, 15, 15, 10, 10, 10, 10, 10], // sums to 100%
      backgroundColor: [
        "#1d1b1c", // primary-color (dark)
        "#437f57", // success-color (green)
        "#7b93AD", // info-color (blue)
        "#d96d6d", // danger-color (red)
        "#dcb285", // brown-color (tan)
        "#252422", // card-black-color (black)
        "#b8d8d8", // card-background-blue (light blue)
        "#d5e5a3"  // card-background-green (light green)
      ],
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// RTD (1 brand)
const chartRTD = {
  data: {
    labels: ["NITRO"],
    datasets: [{
      data: [100],
      backgroundColor: ["#252422"], // card-black-color (distinctive dark)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$5,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Cocktails (1 brand)
const chartCocktails = {
  data: {
    labels: ["House:Drinks"],
    datasets: [{
      data: [100],
      backgroundColor: ["#d5e5a3"], // card-background-green (light green)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$5,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Cider (1 brand)
const chartCider = {
  data: {
    labels: ["Orchard Storm"],
    datasets: [{
      data: [100],
      backgroundColor: ["#b8d8d8"], // card-background-blue (light blue)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Mead (1 brand)
const chartMead = {
  data: {
    labels: ["BEE"],
    datasets: [{
      data: [100],
      backgroundColor: ["#ffe28c"], // card-background-yellow (yellow)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Spirits (6 brands)
const chartSpirits = {
  data: {
    labels: [
      "Hector's",
      "Curious Garden",
      "Curiosity",
      "Divergence",
      "Ariki",
      "Nitro XXX"
    ],
    datasets: [{
      data: [25, 20, 15, 15, 15, 10],
      backgroundColor: [
        "#1d1b1c", // primary-color (dark)
        "#437f57", // success-color (green)
        "#7b93AD", // info-color (blue)
        "#d96d6d", // danger-color (red)
        "#ffe28c", // card-background-yellow (bright yellow)
        "#baa9ba"  // card-background-purple (purple)
      ],
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Bitters (1 brand)
const chartBitters = {
  data: {
    labels: ["Australian Bitters Company"],
    datasets: [{
      data: [100],
      backgroundColor: ["#ff8f5e"], // card-background-orange (orange)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};

// Non-Alc (1 brand)
const chartNonAlc = {
  data: {
    labels: ["Warner's 0%"],
    datasets: [{
      data: [100],
      backgroundColor: ["#d6c1ab"], // card-background-brown (beige)
      borderWidth: 0
    }]
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: { label: ctx => `${ctx.label}: ${ctx.parsed}%` }
      },
      title: {
        display: true,
        text: "$10,000",
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 }
      }
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      x: { display: false, grid: { display: false, drawBorder: false } },
      y: { display: false, grid: { display: false, drawBorder: false } }
    }
  }
};


const chartExample5 = {
  data: {
    // ← 4 labels here, one per slice
    labels: ["Te Pa Reserve", "Montford Estate", "Craft Brew Co", "Healthy Sips"],
    datasets: [
      {
        // no more `labels:` here
        data: [35, 30, 20, 15],           // 4 values, sums to 100
        backgroundColor: [
          "#1d1b1c", // primary-color (dark)
          "#d96d6d", // danger-color (red)
          "#b8d8d8", // card-background-blue (light blue)
          "#ffe28c"  // card-background-yellow (bright yellow)
        ],
        borderWidth: 0,
        // barPercentage is ignored by Doughnut
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,            // still hidden
      },
      tooltip: {                   // v3+ API
        enabled: true,
        callbacks: {
          label: (ctx) => {
            // show e.g. "Te Pa Reserve: 35%"
            return `${ctx.label}: ${ctx.parsed}%`;
          },
        },
      },
      title: {
        display: true,
        // text: "35%",               // your “highlight” slice
        position: "bottom",
        color: "#66615c",
        font: { weight: 400, size: 30 },
      },
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      y: { ticks: { display: false }, grid: { display: false, drawBorder: false } },
      x: { ticks: { display: false }, grid: { display: false, drawBorder: false } },
    },
  },
};


// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample6 = {
  data: {
    labels: [1, 2],
    datasets: [
      {
        label: "Emails",
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: ["#fcc468", "#f4f3ef"],
        borderWidth: 0,
        barPercentage: 1.6,
        data: [34, 66],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      title: {
        display: true,
        // text: "34%",
        position: "bottom",
        color: "#66615c",
        font: {
          weight: 400,
          size: 30,
        },
      },
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample7 = {
  data: {
    labels: [1, 2],
    datasets: [
      {
        label: "Emails",
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: ["#f17e5d", "#f4f3ef"],
        borderWidth: 0,
        barPercentage: 1.6,
        data: [80, 20],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      title: {
        display: true,
        text: "80%",
        position: "bottom",
        color: "#66615c",
        font: {
          weight: 400,
          size: 30,
        },
      },
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Dashboard.js
// #########################################
const chartExample8 = {
  data: {
    labels: [1, 2],
    datasets: [
      {
        label: "Emails",
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: ["#66615b", "#f4f3ef"],
        borderWidth: 0,
        barPercentage: 1.6,
        data: [11, 89],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
      title: {
        display: true,
        text: "11%",
        position: "bottom",
        color: "#66615c",
        font: {
          weight: 400,
          size: 30,
        },
      },
    },
    maintainAspectRatio: false,
    cutout: "90%",
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Charts.js
// #########################################

const chartExample9 = {
  data: {
    labels: ["6pm", "9pm", "11pm", "2am", "4am", "6am", "8am"],
    datasets: [
      {
        label: "Active Users",
        borderColor: "#f17e5d",
        pointBackgroundColor: "#f17e5d",
        pointRadius: 3,
        pointHoverRadius: 3,
        lineTension: 0,
        fill: true,
        borderWidth: 3,
        barPercentage: 1.6,
        data: [200, 250, 300, 350, 280, 330, 400],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },
    scales: {
      y: {
        ticks: {
          color: "#9f9f9f",
          beginAtZero: false,
          maxTicksLimit: 5,
        },
        grid: {
          drawBorder: false,
          borderDash: [8, 5],
          zeroLineColor: "transparent",
          color: "#9f9f9f",
        },
      },
      x: {
        grid: {
          drawBorder: false,
          borderDash: [8, 5],
          color: "#9f9f9f",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          color: "#9f9f9f",
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Charts.js
// #########################################

const chartExample10 = {
  data: {
    labels: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
    datasets: [
      {
        label: "Data",
        borderColor: "#fcc468",
        fill: true,
        backgroundColor: "#fcc468",
        hoverBorderColor: "#fcc468",
        borderWidth: 5,
        barPercentage: 0.4,
        data: [
          100, 120, 80, 100, 90, 130, 110, 100, 80, 110, 130, 140, 130, 120,
          130, 80, 100, 90, 120, 130,
        ],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        tooltipFillColor: "rgba(0,0,0,0.5)",
        tooltipFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipFontSize: 14,
        tooltipFontStyle: "normal",
        tooltipFontColor: "#fff",
        tooltipTitleFontFamily:
          "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
        tooltipTitleFontSize: 14,
        tooltipTitleFontStyle: "bold",
        tooltipTitleFontColor: "#fff",
        tooltipYPadding: 6,
        tooltipXPadding: 6,
        tooltipCaretSize: 8,
        tooltipCornerRadius: 6,
        tooltipXOffset: 10,
      },
    },
    scales: {
      y: {
        ticks: {
          color: "#9f9f9f",
          fontStyle: "bold",
          beginAtZero: true,
          maxTicksLimit: 5,
          padding: 20,
        },
        grid: {
          zeroLineColor: "transparent",
          display: true,
          drawBorder: false,
          color: "#9f9f9f",
        },
      },
      x: {
        grid: {
          zeroLineColor: "white",
          display: false,
          drawBorder: false,
          color: "transparent",
        },
        ticks: {
          padding: 20,
          color: "#9f9f9f",
          fontStyle: "bold",
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Charts.js
// #########################################

const chartExample11 = {
  data: {
    labels: [1, 2, 3],
    datasets: [
      {
        label: "Emails",
        pointRadius: 0,
        pointHoverRadius: 0,
        backgroundColor: ["#e3e3e3", "#4acccd", "#fcc468"],
        borderWidth: 0,
        barPercentage: 1.6,
        data: [542, 480, 430],
      },
    ],
  },
  options: {
    plugins: {
      legend: {
        display: false,
      },

      tooltips: {
        enabled: false,
      },
    },
    maintainAspectRatio: false,
    scales: {
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.05)",
        },
      },
      x: {
        grid: {
          drawBorder: false,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          display: false,
        },
      },
    },
  },
};

// #########################################
// // // used inside src/views/Charts.js
// #########################################

const chartExample12 = {
  data: (canvas) => {
    return {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
      ],
      datasets: [
        {
          borderColor: "#6bd098",
          backgroundColor: "#6bd098",
          pointRadius: 0,
          pointHoverRadius: 0,
          borderWidth: 3,
          tension: 0.4,
          fill: true,
          data: [300, 310, 316, 322, 330, 326, 333, 345, 338, 354],
        },
        {
          borderColor: "#f17e5d",
          backgroundColor: "#f17e5d",
          pointRadius: 0,
          pointHoverRadius: 0,
          borderWidth: 3,
          tension: 0.4,
          fill: true,
          data: [320, 340, 365, 360, 370, 385, 390, 384, 408, 420],
        },
        {
          borderColor: "#fcc468",
          backgroundColor: "#fcc468",
          pointRadius: 0,
          pointHoverRadius: 0,
          borderWidth: 3,
          tension: 0.4,
          fill: true,
          data: [370, 394, 415, 409, 425, 445, 460, 450, 478, 484],
        },
      ],
    };
  },
  options: {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    scales: {
      y: {
        ticks: {
          color: "#9f9f9f",
          beginAtZero: false,
          maxTicksLimit: 5,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      x: {
        barPercentage: 1.6,
        grid: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          padding: 20,
          color: "#9f9f9f",
        },
      },
    },
  },
};

module.exports = {
  // used for Charts and Dashboard views
  chartExample1,
  // used for Dashboard view
  chartExample2,
  // used for Dashboard view
  chartExample3,
  // used for Charts and Dashboard views
  chartExample4,
  // used for Dashboard view
  chartExample5,
  // used for Dashboard view
  chartExample6,
  // used for Dashboard view
  chartExample7,
  // used for Dashboard view
  chartExample8,
  // used for Charts view
  chartExample9,
  // used for Charts view
  chartExample10,
  // used for Charts view
  chartExample11,
  // used for Charts view
  chartExample12,
  chartBitters,
  chartCider,
  chartWine,
  chartNonAlc,
  chartSpirits,
  chartMead,
  chartRTD,
  chartCocktails,
  // Brand color mapping function
  getBrandColor,
  brandColorPalette,
};
